import { types } from "../../reducers/types";
import axios from "axios";
import { store } from "../../App";
import { URL, URL_COHORT } from "../../api/tklEnvironments";
//import { sortingByPropertiesFunction } from "../../components/activity-path/Fragments/DiscussionForm/learnerPopup";
export const addInitialComments = (
  discussionComment,
  commentSlug,
  upvotes,
  commentedDt,
  itemIndex,
  label,
  sortData
) => {
  return (dispatch) => {
    let dt = new Date(commentedDt);
    let commentData = {
      userName: "Alva Alv",
      // pSlug: "",
      comment: discussionComment,
      commentIdentifier: commentSlug, //parentCommentIdentifier,
      upCount: upvotes, //
      updatedAt: dt, //
      cohortsDiscussionReplies: [], //
    };
    dispatch({
      type: types.ADD_INITIAL_COMMENTS_TO_DISCUSSION_FORUM,
      payload: commentData,
      itemIndex: itemIndex,
      label: label,
      sortData: sortData,
    });
  };
};

export const saveInitialComment = (
  itemIndex,
  commentData,
  label,
  sortData,
  introId
) => {
  let acitivtyUrl = introId
    ? "add-introduction-cohort-discussion-comment"
    : "add-cohort-discussion-comment";
  return (dispatch) => {
    let applicationData =
      store && store.getState().fragments.application.Fragments[itemIndex];
    
    // Create optimistic comment object
    const optimisticComment = {
      comment: commentData,
      commentIdentifier: Date.now(), // Temporary ID
      userId: store.getState().users.userData?.id,
      user: {
        firstName: store.getState().users.userData?.firstName || "You",
        lastName: store.getState().users.userData?.lastName || "",
        userSlug: store.getState().users.userData?.userSlug
      },
      updatedAt: new Date().toISOString(),
      upCount: 0,
      parentCommentId: null,
      [introId ? "introductionCohortDiscussionReplies" : "cohortsDiscussionReplies"]: []
    };

    // Dispatch optimistic update to add the comment immediately to UI
    dispatch({
      type: types.ADD_OPTIMISTIC_COMMENT,
      payload: {
        itemIndex,
        optimisticComment,
        introId
      }
    });
    
    // Then save in background
    let sendData = {};
    sendData["comment"] = commentData;
    sendData["isReply"] = false;
    sendData[
      introId ? "introStepFragmentConfigSlug" : "stepFragmentConfigSlug"
    ] = applicationData.fragmentSlug;
    axios
      .post(`${URL_COHORT}/${acitivtyUrl}`, sendData)
      .then(function (response) {
        console.log("Comment saved successfully");
        // Refresh to get the actual server data with proper IDs
        dispatch(
          getCommentsDataBySlug(
            applicationData.fragmentSlug,
            itemIndex,
            sortData,
            introId
          )
        );
      })
      .catch(function (error) {
        console.error("..error", error);
        // On error, remove optimistic update and refresh to get actual state
        dispatch({
          type: types.REMOVE_OPTIMISTIC_COMMENT,
          payload: {
            itemIndex,
            optimisticComment,
            introId
          }
        });
        dispatch(
          getCommentsDataBySlug(
            applicationData.fragmentSlug,
            itemIndex,
            sortData,
            introId
          )
        );
      });
  };
};

export const saveInitialCommentContentDeveloper = (
  itemIndex,
  commentData,
  introId,
  userData,
  userSlug
) => {
  return (dispatch) => {
    let applicationData =
      store && store.getState().fragments.application.Fragments[itemIndex];
    //   console.log(".....userName", userName, userSlug);
    let dt = new Date();
    let sendData = {};
    sendData["comment"] = commentData;
    sendData["isReply"] = false;
    sendData["stepFragmentConfigSlug"] = applicationData.fragmentSlug;
    sendData["user"] = userData; // "Alva Alv";
    sendData["commentIdentifier"] = commentData;
    sendData["parentCommentIdentifier"] = null;
    sendData["upCount"] = 0;
    sendData["updatedAt"] = dt;
    sendData[
      introId
        ? "introductionCohortDiscussionReplies"
        : "cohortsDiscussionReplies"
    ] = [];
    sendData["userSlug"] = userSlug;
    // let commentsData = [];
    // commentsData.push(sendData);
    dispatch({
      type: types.ADD_INITIAL_COMMENTS_TO_DISCUSSION_FORUM,
      label: "discussionForumComments",
      payload: sendData,
      itemIndex: itemIndex,
    });
  };
};

export const addReplytoComment = (
  itemIndex,
  commentData,
  commentSlug,
  sortData,
  introId
) => {
  return (dispatch) => {
    let activityUrl = introId
      ? "add-introduction-cohort-discussion-comment"
      : "add-cohort-discussion-comment";
    let applicationData =
      store && store.getState().fragments.application.Fragments[itemIndex];
    
    // Create optimistic reply object
    const optimisticReply = {
      comment: commentData,
      commentIdentifier: Date.now(), // Temporary ID
      userId: store.getState().users.userData?.id,
      user: {
        firstName: store.getState().users.userData?.firstName || "You",
        lastName: store.getState().users.userData?.lastName || "",
        userSlug: store.getState().users.userData?.userSlug
      },
      updatedAt: new Date().toISOString(),
      upCount: 0,
      parentCommentId: null, // This will be set by finding the parent
      [introId ? "introductionCohortDiscussionReplies" : "cohortsDiscussionReplies"]: []
    };

    // Dispatch optimistic update to add the reply immediately to UI
    dispatch({
      type: types.ADD_OPTIMISTIC_REPLY,
      payload: {
        itemIndex,
        parentCommentSlug: commentSlug,
        optimisticReply,
        introId
      }
    });
    
    // Then save in background
    let sendData = {};
    sendData["comment"] = commentData;
    sendData["isReply"] = true;
    sendData[
      introId ? "introStepFragmentConfigSlug" : "stepFragmentConfigSlug"
    ] = applicationData.fragmentSlug;
    sendData["commentIdentifier"] = commentSlug;
    axios
      .post(`${URL_COHORT}/${activityUrl}`, sendData)
      .then(function (response) {
        console.log("Reply saved successfully");
        // Refresh to get the actual server data with proper IDs
        dispatch(
          getCommentsDataBySlug(
            applicationData.fragmentSlug,
            itemIndex,
            sortData,
            introId
          )
        );
      })
      .catch(function (error) {
        console.error("..error", error);
        // On error, remove optimistic update and refresh to get actual state
        dispatch({
          type: types.REMOVE_OPTIMISTIC_REPLY,
          payload: {
            itemIndex,
            parentCommentSlug: commentSlug,
            optimisticReply,
            introId
          }
        });
        dispatch(
          getCommentsDataBySlug(
            applicationData.fragmentSlug,
            itemIndex,
            sortData,
            introId
          )
        );
      });
  };
};
// export const addReplytoCommentContentDeveloper = (
//   itemIndex,
//   commentData,
//   commentSlug,
//   sortData
// ) => {
//   return (dispatch) => {
//     let applicationData =
//       store && store.getState().fragments.application.Fragments[itemIndex];
//     let sendData = {};
//     sendData["comment"] = commentData;
//     sendData["isReply"] = true;
//     sendData["stepFragmentConfigSlug"] = applicationData.fragmentSlug;
//     sendData["commentIdentifier"] = commentSlug;
//     axios
//       .post(`${URL_COHORT}/add-cohort-discussion-comment`, sendData)
//       .then(function (response) {
//         if (response.data) {
//           dispatch(
//             getCommentsDataBySlug(
//               applicationData.fragmentSlug,
//               itemIndex,
//               sortData
//             )
//           );
//         }
//       })
//       .catch(function (error) {
//         console.error("..error", error);
//       });
//   };
// };

export const getCommentsDataBySlug = (
  fragmentSlug,
  itemIndex,
  sortData,
  introId,
  isInstructor,
  userSlug
) => {
  return (dispatch) => {
    let apiUrl = introId
      ? `get-introduction-cohort-discussion-comment/${fragmentSlug}${
          isInstructor && userSlug && userSlug !== "null"
            ? `?userSlug=${userSlug}`
            : ""
        }`
      : `get-cohort-discussion-comment/${fragmentSlug}${
          isInstructor && userSlug && userSlug !== "null"
            ? `?userSlug=${userSlug}`
            : ""
        }`;
    axios
      .get(`${URL_COHORT}/${apiUrl}`)
      .then(function (response) {
        let newData = [];
        response.data.forEach((dataItem, index) => {
          if (introId) {
            newData.push({
              user: dataItem["user"],
              comment: dataItem["comment"],
              commentIdentifier: dataItem["commentIdentifier"],
              upCount: dataItem["upCount"],
              updatedAt: dataItem["updatedAt"],
              introductionCohortDiscussionReplies:
                dataItem["introductionCohortDiscussionReplies"],
              parentCommentIdentifier: dataItem["parentCommentIdentifier"],
              authUserLike: dataItem["authUserLike"],
            });
          } else {
            newData.push({
              user: dataItem["user"],
              comment: dataItem["comment"],
              commentIdentifier: dataItem["commentIdentifier"],
              upCount: dataItem["upCount"],
              updatedAt: dataItem["updatedAt"],
              cohortsDiscussionReplies: dataItem["cohortsDiscussionReplies"],
              parentCommentIdentifier: dataItem["parentCommentIdentifier"],
              authUserLike: dataItem["authUserLike"],
            });
          }
        });

        function sortingByPropertiesFunction(instance1, instance2) {
          if (
            !sortData ||
            sortData === "Newest first" ||
            sortData === "Most Recent"
          ) {
            return (
              new Date(instance2.updatedAt).getTime() -
              new Date(instance1.updatedAt).getTime()
            );
          } else if (sortData === "Most Replies") {
            if (introId) {
              if (
                instance1.introductionCohortDiscussionReplies?.length <
                instance2.introductionCohortDiscussionReplies?.length
              )
                return 1;
              return -1;
            } else {
              if (
                instance1.cohortsDiscussionReplies?.length <
                instance2.cohortsDiscussionReplies?.length
              )
                return 1;
              return -1;
            }
          } else if (sortData === "By Likes") {
            if (instance1.upCount < instance2.upCount) return 1;
            return -1;
          }
        }
        if (
          !sortData ||
          sortData === "Newest first" ||
          sortData === "Most Recent" ||
          sortData === "Most Replies" ||
          sortData === "By Likes"
        ) {
          let sorted_array = [...newData];
          sorted_array.sort(sortingByPropertiesFunction);

          dispatch({
            type: types.TOTAL_COMMENTS_FOR_FORUM,
            payload: sorted_array,
            itemIndex: itemIndex,
          });
        } else {
          dispatch({
            type: types.TOTAL_COMMENTS_FOR_FORUM,
            payload: newData,
            itemIndex: itemIndex,
          });
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };
};

export const editReplyToComment = (
  itemIndex,
  commentData,
  commentSlug,
  sortData,
  introId
) => {
  return (dispatch) => {
    let activityUrl = introId
      ? "update-introduction-cohort-discussion-comment"
      : "update-cohort-discussion-comment";
    
    // Optimistic update: Update comment in Redux immediately
    dispatch({
      type: types.COMMENT_SLUG_UPDATE,
      payload: {
        itemIndex: itemIndex,
        commentSlug: commentSlug,
        comment: commentData,
      },
    });
    
    // Then save in background (non-blocking)
    let sendData = {};
    sendData["comment"] = commentData;
    sendData["commentIdentifier"] = commentSlug;
    axios
      .put(`${URL_COHORT}/${activityUrl}`, sendData)
      .then(function (response) {
        console.log("Comment saved successfully");
        // Force refresh to ensure UI is updated with server data
        let applicationData = store.getState().fragments.application.Fragments[itemIndex];
        if (applicationData) {
          dispatch(
            getCommentsDataBySlug(
              applicationData.fragmentSlug,
              itemIndex,
              sortData,
              introId
            )
          );
        }
      })
      .catch(function (error) {
        console.error("Error saving comment:", error);
        // On error, refresh to get actual server state
        let applicationData = store.getState().fragments.application.Fragments[itemIndex];
        if (applicationData) {
          dispatch(
            getCommentsDataBySlug(
              applicationData.fragmentSlug,
              itemIndex,
              sortData,
              introId
            )
          );
        }
      });
  };
};

export const deleteDiscussionComment = (
  itemIndex,
  commentSlug,
  sortData,
  introId
) => {
  return (dispatch) => {
    let activityUrl = introId
      ? "delete-introduction-cohort-discussion-comment"
      : "delete-cohort-discussion-comment";
    let applicationData =
      store && store.getState().fragments.application.Fragments[itemIndex];
    axios
      .delete(`${URL_COHORT}/${activityUrl}/${commentSlug}`)
      .then(function (response) {
        if (response) {
          dispatch(
            getCommentsDataBySlug(
              applicationData.fragmentSlug,
              itemIndex,
              sortData,
              introId
            )
          );
        }
      })
      .catch(function (error) {
        console.error("..error", error);
      });
  };
};

export const upVote = (ID, itemIndex, sortData, introId) => {
  let payload = {};
  payload["commentIdentifier"] = ID;
  return async (dispatch) => {
    axios
      .post(
        `${URL_COHORT}/${introId ? "introduction-up-votes" : "up-votes"}`,
        payload
      )
      .then((response) => {
        let applicationData =
          store && store.getState().fragments.application.Fragments[itemIndex];
        dispatch(
          getCommentsDataBySlug(
            applicationData.fragmentSlug,
            itemIndex,
            sortData,
            introId
          )
        );
      });
  };
};
export const downVote = (ID, itemIndex, sortData, introId) => {
  let payload = {};
  payload["commentIdentifier"] = ID;
  return async (dispatch) => {
    axios
      .post(
        `${URL_COHORT}/${introId ? "introduction-up-votes" : "up-votes"}`,
        payload
      )
      .then((response) => {
        let applicationData =
          store && store.getState().fragments.application.Fragments[itemIndex];
        dispatch(
          getCommentsDataBySlug(
            applicationData.fragmentSlug,
            itemIndex,
            sortData,
            introId
          )
        );
      })
      .catch((error) => {
        console.log("...error");
      });
  };
};
